export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-volume-none-617bcfa20167c63aa8034c1a1aa78474.svg";